export const variant01 = {
  hidden: { opacity: 0, y: 5 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 5 },
};

export const variant02 = {
  hidden: { opacity: 0, y: -10 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10, transition: { delay: 0, duration: 0.6 } },
};

export const variantContainer = (delay, hide) => {
  return {
    hidden: { opacity: 0 },
    visible: {
      opacity: !hide ? 1 : 0,
      transition: {
        staggerChildren: 0.1,
        delayChildren: delay,
      },
    },
  };
};

export const container = (delay) => ({
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.02,
      delayChildren: delay,
    },
  },
  exit: {
    transition: {
      staggerChildren: 0.02,
      staggerDirection: -1,
      delayChildren: delay,
    },
  },
});

export const item = {
  hidden: { bottom: "-110%" },
  visible: { bottom: 0, transition: { duration: 0.4 } },
  exit: { bottom: "-110%", transition: { duration: 0.4 } },
};

export const border = {
  hidden: { width: 0 },
  visible: { width: "100%", transition: { duration: 0.2, delay: 1.2 } },
  exit: { width: 0, transition: { duration: 0.2 } },
};
